import * as React from "../_snowpack/pkg/react.js";
import IOPEntry from "./components/IOPEntry.js";
import SocietyEntry from "./components/SocietyEntry.js";
import {alphabetizeByFullname, alphabetizeNestedArr, separateEntriesByLocale} from "./utils.js";
const App = ({allSocieties}) => {
  const separatedSocieties = [...separateEntriesByLocale(allSocieties)].sort(alphabetizeNestedArr);
  const EuropeanPhysicalSociety = allSocieties.filter((s) => s.full_name === "European Physical Society")[0];
  return /* @__PURE__ */ React.createElement("section", {
    className: "p-6 w-full"
  }, /* @__PURE__ */ React.createElement("article", null, /* @__PURE__ */ React.createElement("h1", {
    className: "text-2xl mb-2 text-blue-800 font-bold"
  }, "List of Reciprocal Member Societies"), /* @__PURE__ */ React.createElement("p", null, "Reciprocal Societies are national physical societies that have signed an agreement with the American Physical Society to exchange certain membership privileges. The privileges granted to the members of the Reciprocal Societies are enumerated below."), /* @__PURE__ */ React.createElement("ol", {
    className: "list-decimal pl-4 m-4 ml-0"
  }, /* @__PURE__ */ React.createElement("li", {
    className: "pl-4"
  }, "Members of the Reciprocal Society may submit papers to APS meetings with the same privileges and limitations as APS members."), /* @__PURE__ */ React.createElement("li", {
    className: "pl-4"
  }, "Reciprocal Society members can only register for APS meetings at the full Regular APS member rates.")), /* @__PURE__ */ React.createElement("p", null, "Conversely,"), /* @__PURE__ */ React.createElement("ol", {
    className: "list-decimal pl-4 mt-4"
  }, /* @__PURE__ */ React.createElement("li", {
    className: "pl-4"
  }, "Members of the APS may submit papers to Reciprocal Society meetings with the same privileges and limitations as Reciprocal Society members."), /* @__PURE__ */ React.createElement("li", {
    className: "pl-4"
  }, "APS members may register at Reciprocal Society meetings at Reciprocal Society member rates."))), /* @__PURE__ */ React.createElement("article", null, /* @__PURE__ */ React.createElement("h2", {
    className: "text-xl text-center p-4"
  }, "Reciprocal Societies by Region"), /* @__PURE__ */ React.createElement("ul", {
    className: "list-disc pl-8 mb-2 flex w-full justify-around underline text-blue-800"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "flex flex-col"
  }, /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("a", {
    href: "#africa"
  }, "Africa")), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("a", {
    href: "#asia_and_the_pacific"
  }, "Asia & the Pacific")), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("a", {
    href: "#caribbean"
  }, "Caribbean")), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("a", {
    href: "#europe"
  }, "Europe"))), /* @__PURE__ */ React.createElement("div", {
    className: "flex flex-col"
  }, /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("a", {
    href: "#middle_east"
  }, "Middle East")), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("a", {
    href: "#north_america"
  }, "North America")), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("a", {
    href: "#south_america"
  }, "South America")))), separatedSocieties.map(([continent, countriesArr], idx1) => /* @__PURE__ */ React.createElement(React.Fragment, {
    key: `${continent}/${idx1}`
  }, /* @__PURE__ */ React.createElement("h3", {
    id: continent.toLowerCase().split(" ").join("_"),
    className: "font-bold text-xl text-blue-800 pt-4"
  }, continent), continent === "Europe" ? /* @__PURE__ */ React.createElement(SocietyEntry, {
    society: EuropeanPhysicalSociety
  }) : /* @__PURE__ */ React.createElement(React.Fragment, null), /* @__PURE__ */ React.createElement("div", {
    className: "pl-4 my-2 border-l"
  }, [...countriesArr].sort(alphabetizeNestedArr).map(([country, dataArr], idx2) => /* @__PURE__ */ React.createElement(React.Fragment, {
    key: `${country}/${idx2}`
  }, /* @__PURE__ */ React.createElement("p", {
    className: "font-bold pt-2"
  }, country), [...dataArr].sort(alphabetizeByFullname).filter((item) => item.full_name !== "European Physical Society").map((s) => s.full_name === "The Institute of Physics" ? /* @__PURE__ */ React.createElement(IOPEntry, {
    key: s.id,
    society: s
  }) : /* @__PURE__ */ React.createElement(SocietyEntry, {
    key: s.id,
    society: s
  })))))))));
};
export default App;
